import { type PropsWithChildren, useContext } from 'react';

import AIProfileChatChannel from '@/channels/AIProfileChatChannel';
import GeneratedDocumentsChannel from '@/channels/GeneratedDocumentsChannel';
import OperationsLogsChannel from '@/channels/OperationsLogsChannel';
import PersonAvailabilityChannel from '@/channels/PersonAvailabilityChannel';
import PersonMessagesChannel from '@/channels/PersonMessagesChannel';
import RewardCardAccountsChannel from '@/channels/RewardCardAccountsChannel';
import ScheduleExpectationsChannel from '@/channels/ScheduleExpectationsChannel';
import AppContext from '@/contexts/appContext';
import PersonContext from '@/pages/Person/PersonContext';

/**
 * Component to add websocket ChannelProvider wrappers as necessary.
 * ChannelProviders must be a parent of any useChannelData hooks that use
 * the same channel. If a component is a Route Outlet component and uses the useChannel
 * hook, then this is probably the best place to wrap the component.
 * @param children
 */
const PersonChannels = ({ children }: PropsWithChildren) => {
  const { currentUser } = useContext(AppContext);
  const { person } = useContext(PersonContext);

  return (
    <PersonMessagesChannel personId={person.id}>
      <OperationsLogsChannel personId={person.id}>
        <RewardCardAccountsChannel personId={person.id}>
          <GeneratedDocumentsChannel personId={person.id}>
            <PersonAvailabilityChannel personId={person.id}>
              <ScheduleExpectationsChannel personId={person.id}>
                <AIProfileChatChannel personId={person.id} userId={currentUser?.id}>
                  {children}
                </AIProfileChatChannel>
              </ScheduleExpectationsChannel>
            </PersonAvailabilityChannel>
          </GeneratedDocumentsChannel>
        </RewardCardAccountsChannel>
      </OperationsLogsChannel>
    </PersonMessagesChannel>
  );
};

export default PersonChannels;
